
import { defineComponent, inject, ref } from 'vue'
import RandselDialog from '@/components/Abstract/RandselDialog.vue'

export default defineComponent({
  name: 'BagsizeDialog',
  components: {
    RandselDialog
  },
  setup() {

    return {
    }
  }
})
